<template lang="pug">
.res
  .title {{$t('me.res.title')}}
  .cards
    .card(v-for="(r, i) in getReses" :key="i")
      blue-shadow2
      res-info-card(:res="r" :size="i===0? 'l' : 'm'"  :id="r.resId" from="/me/res")
    //res-info-card-l

  
</template>
<script>
import DatePicker from '@/components/res/DatePicker'
import Flex from '@/components/Flex'
import { mapGetters, mapMutations } from 'vuex'
import ResInfoCardL from '@/components/me/ResInfoCardL'
import BlueShadow2 from '@/components/wedgits/BlueShadow2'
import ResInfoCard from '@/components/me/ResInfoCard'
export default {
  name: 'Res',
  components: { ResInfoCard, BlueShadow2, ResInfoCardL, Flex, DatePicker },
  props: {},
  created() {},
  data() {
    return {
      timeTable: [],
    }
  },
  computed: {
    ...mapGetters('app', ['getReses']),
  },
  methods: {
    ...mapMutations('app', ['setRouterBack']),
    onNext() {},
  },
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.res
  position: absolute
  width: 100%
  height: 100%
  //padding: pxToRem(30)
  overflow-y: auto
  overflow-x: hidden
  -webkit-overflow-scrolling: touch
  padding: 0
  .title
    pointer-events: none
    padding: pxToRem(30)
    position: fixed
    width: 100%
    background: white
    z-index: 100
  .cards
    padding: pxToRem(30)
    position: relative
    margin-top: pxToRem(100)
    .card
      position: relative
      margin-bottom: pxToRem(40)
      .res-info-card
        background: #ffffff
        position: relative
        z-index: 10
      .blue-shadow2
        z-index: 1 !important

.slide-enter-active, .slide-leave-active
  transition: all 0.5s
.slide-enter, .slide-leave-to
  transform: translateX(-100%)
</style>
